import React, { useRef, useState, useEffect } from 'react';

const fmt = (s) => {
  if (!s || !isFinite(s)) return '0:00';
  const m = Math.floor(s / 60);
  const sec = Math.floor(s % 60);
  return `${m}:${sec < 10 ? '0' : ''}${sec}`;
};

const PlayIcon = () => (<svg viewBox="0 0 24 24" width="30" height="30"><path d="M8 5.5v13l11-6.5z" fill="currentColor" /></svg>);
const PauseIcon = () => (<svg viewBox="0 0 24 24" width="30" height="30"><rect x="6" y="5" width="4.2" height="14" rx="1.4" fill="currentColor" /><rect x="13.8" y="5" width="4.2" height="14" rx="1.4" fill="currentColor" /></svg>);
const CloseIcon = () => (<svg viewBox="0 0 24 24" width="18" height="18"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" /></svg>);

// 9 barre equalizzatore con durate/ritardi diversi per un movimento organico
const BARS = [
  { d: '0.9s', delay: '0s' }, { d: '1.3s', delay: '.15s' }, { d: '0.7s', delay: '.05s' },
  { d: '1.1s', delay: '.25s' }, { d: '0.8s', delay: '.1s' }, { d: '1.25s', delay: '.2s' },
  { d: '0.95s', delay: '.05s' }, { d: '1.15s', delay: '.18s' }, { d: '0.85s', delay: '.12s' },
];

export default function AudioPlayer({ src, titolo, sottotitolo, onClose }) {
  const aRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [cur, setCur] = useState(0);
  const [dur, setDur] = useState(0);
  const [err, setErr] = useState(false);

  useEffect(() => {
    const a = aRef.current;
    if (!a) return;
    const onT = () => setCur(a.currentTime);
    const onL = () => setDur(a.duration || 0);
    const onPlay = () => setPlaying(true);
    const onPause = () => setPlaying(false);
    const onEnd = () => { setPlaying(false); setCur(0); };
    const onErr = () => setErr(true);
    a.addEventListener('timeupdate', onT);
    a.addEventListener('loadedmetadata', onL);
    a.addEventListener('play', onPlay);
    a.addEventListener('pause', onPause);
    a.addEventListener('ended', onEnd);
    a.addEventListener('error', onErr);
    a.play().catch(() => {});   // parte subito: l'overlay si apre da un tap (gesto utente)
    return () => {
      a.pause();
      a.removeEventListener('timeupdate', onT);
      a.removeEventListener('loadedmetadata', onL);
      a.removeEventListener('play', onPlay);
      a.removeEventListener('pause', onPause);
      a.removeEventListener('ended', onEnd);
      a.removeEventListener('error', onErr);
    };
  }, []);

  const toggle = () => {
    const a = aRef.current;
    if (!a) return;
    if (a.paused) a.play().catch(() => {}); else a.pause();
  };
  const seek = (e) => {
    const a = aRef.current;
    if (!a || !dur) return;
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    a.currentTime = Math.max(0, Math.min(1, x / rect.width)) * dur;
  };

  const pct = dur ? (cur / dur) * 100 : 0;

  return (
    <div className={`m-player ${playing ? 'playing' : 'paused'}`}>
      <audio ref={aRef} src={src} preload="auto" />
      <button className="pl-close" onClick={onClose} aria-label="Chiudi"><CloseIcon /></button>

      <div className="pl-head">
        <div className="pl-tag">Registrazione 456</div>
        <div className="pl-num m-disp">{titolo}</div>
        {sottotitolo && <div className="pl-sub">{sottotitolo}</div>}
      </div>

      <div className="pl-eq" aria-hidden>
        {BARS.map((b, i) => (
          <i key={i} style={{ animationDuration: b.d, animationDelay: b.delay }} />
        ))}
      </div>

      {err ? (
        <div className="pl-err">Registrazione non disponibile.</div>
      ) : (
        <>
          <button className="pl-play" onClick={toggle} aria-label={playing ? 'Pausa' : 'Riproduci'}>
            {playing ? <PauseIcon /> : <PlayIcon />}
          </button>
          <div className="pl-bar-wrap">
            <div className="pl-bar" onClick={seek}>
              <div className="pl-fill" style={{ width: `${pct}%` }} />
            </div>
            <div className="pl-time">
              <span>{fmt(cur)}</span><span>{fmt(dur)}</span>
            </div>
          </div>
        </>
      )}

      <button className="pl-end" onClick={onClose}><CloseIcon /> Chiudi</button>
    </div>
  );
}
